module.exports = __webpack_public_path__ + "img/winnings-hour.35731484.png";